import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../App';

export default function Chatbot() {
  const { user } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    { ruolo: 'bot', messaggio: 'Ciao! Sono l\'assistente di VerificaIncentivi.it. Come posso aiutarti a trovare gli incentivi per la tua azienda?' }
  ]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [sessionId] = useState(`chat_${Date.now()}`);
  const messagesEnd = useRef(null);

  useEffect(() => {
    messagesEnd.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const sendMessage = async () => {
    if (!input.trim() || loading) return;
    const msg = input.trim();
    setInput('');
    setMessages(prev => [...prev, { ruolo: 'user', messaggio: msg }]);
    setLoading(true);

    try {
      const res = await axios.post('/api/chat/message', {
        message: msg,
        session_id: sessionId,
        user_id: user?.id
      });
      setMessages(prev => [...prev, { ruolo: 'bot', messaggio: res.data.reply }]);
    } catch {
      setMessages(prev => [...prev, { ruolo: 'bot', messaggio: 'Mi scuso, si e verificato un errore. Contattaci su WhatsApp al +39 348 493 2900.' }]);
    }
    setLoading(false);
  };

  return (
    <>
      <button className="chatbot-toggle" onClick={() => setOpen(!open)} title="Assistente Virtuale">
        {open ? '\u2715' : '\uD83D\uDCAC'}
      </button>

      {open && (
        <div className="chatbot-container">
          <div className="chatbot-header">
            <div>
              <strong>Assistente VerificaIncentivi</strong>
              <div style={{ fontSize: 11, opacity: 0.8 }}>Online</div>
            </div>
            <button onClick={() => setOpen(false)} style={{ background: 'none', border: 'none', color: 'white', fontSize: 18, cursor: 'pointer' }}>&times;</button>
          </div>

          <div className="chatbot-messages">
            {messages.map((m, i) => (
              <div key={i} className={`chat-msg ${m.ruolo === 'user' ? 'user' : 'bot'}`}>
                {m.messaggio}
              </div>
            ))}
            {loading && <div className="chat-msg bot">Sto scrivendo...</div>}
            <div ref={messagesEnd} />
          </div>

          <div className="chatbot-input">
            <input
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyPress={e => e.key === 'Enter' && sendMessage()}
              placeholder="Scrivi un messaggio..."
            />
            <button onClick={sendMessage}>&rarr;</button>
          </div>
        </div>
      )}
    </>
  );
}
